import { useEffect, useState } from "react";
import { Dashboard } from "../../components/Dashboard/Dashboard";
import { Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Circular } from "../../components/Circular/Circular";
import connectTopLine from "../../components/HOC/connectTopLine";
import { applyCurrencyFormatters } from "../../common/helper";
import "bootstrap/dist/css/bootstrap.min.css";
import Export from "../../components/Export/Export";
import { toastApiError } from "../../utils/toastApiError";
import useAuth from "../../auth/useAuth";
import { httpApi } from "../../api/httpApi";

const perPageList = [10, 50, 100];

const Daily = ({ datesFilter, brandsFilter }) => {
  const auth = useAuth();
  const [reports, setReports] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    httpApi
        .doGet(`/api/v3/reports/daily?${datesFilter}&${brandsFilter}`)
        .then((response) => {
          setReports(response.reports);
          setStats(response.totalsReport);
        })
        .catch(toastApiError)
        .finally(() => setLoading(false))
  }, [datesFilter, brandsFilter]);

  const columns = [
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "Clicks",
      selector: (row) => row.uniqueClicks,
      sortable: true,
      center: true,
    },
    {
      name: "Registrations",
      selector: (row) => row.registrations,
      sortable: true,
      center: true,
    },
    {
      name: "FTDs",
      selector: (row) => row.ftds,
      sortable: true,
      center: true,
    },
    {
      name: "Deposits",
      selector: (row) => row.numberOfDeposits,
      sortable: true,
      center: true,
      omit: !auth.user.authorities.includes('VIEW_DEPOSITS')
    },
    {
      name: "Deposits Value",
      selector: (row) => row.deposits,
      sortable: true,
      format: "currency",
      center: true,
      omit: !auth.user.authorities.includes('VIEW_DEPOSITS')
    },
    {
      name: "Net Cash",
      selector: (row) => row.netCash,
      sortable: true,
      format: "currency",
      center: true,
      omit: !auth.user.authorities.includes('VIEW_NET_CASH')
    },
    {
      name: "Rev Share Commission",
      selector: (row) => row.revShareCommission,
      sortable: true,
      format: "currency",
      center: true,
    },
    {
      name: "CPA Commission",
      selector: (row) => row.cpaCommission,
      sortable: true,
      format: "currency",
      center: true,
    },
  ];

  return (
    <Row>
      <Dashboard stats={stats} />
      <div className="data__wrapper">
        <DataTable theme="darkCustom"
          title="Daily"
          columns={applyCurrencyFormatters(columns)}
          data={reports}
          progressPending={loading}
          pagination
          progressComponent={<Circular />}
          paginationRowsPerPageOptions={perPageList}
          actions={<Export rows={reports} />}
        />
      </div>
    </Row>
  );
};

export default connectTopLine(true, false, Daily);
